export default __webpack_public_path__ + "static/media/edit_file_text.b2c7a460.png";